(() => {
  if (window.AirtangCartTimerInitialized) return;
  window.AirtangCartTimerInitialized = true;

  const DEFAULT_DURATION_MS = 15 * 60 * 1000;
  const TICK_MS = 1000;

  let deadline = null;
  let previousCount = null;

  const toDurationMs = (timerElements) => {
    const first = timerElements[0];
    if (!first) return DEFAULT_DURATION_MS;

    const seconds = Number(first.dataset.durationSeconds);
    return Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : DEFAULT_DURATION_MS;
  };

  const toCartCount = (timerElements) => {
    return timerElements.reduce((max, element) => {
      const count = Number(element.dataset.cartCount);
      if (!Number.isFinite(count) || count < 0) return max;
      return Math.max(max, count);
    }, 0);
  };

  const formatRemaining = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  };

  const resetDeadline = (durationMs) => {
    deadline = Date.now() + durationMs;
  };

  const render = () => {
    const timerElements = Array.from(document.querySelectorAll('[data-cart-timer]'));
    if (!timerElements.length) return;

    const cartCount = toCartCount(timerElements);
    const durationMs = toDurationMs(timerElements);

    if (cartCount <= 0) {
      deadline = null;
      previousCount = null;
      timerElements.forEach((element) => {
        element.hidden = true;
      });
      return;
    }

    if (deadline === null || previousCount === null || cartCount !== previousCount) {
      resetDeadline(durationMs);
    }

    previousCount = cartCount;

    let remainingMs = deadline - Date.now();
    if (remainingMs <= 0) {
      resetDeadline(durationMs);
      remainingMs = durationMs;
    }

    const formatted = formatRemaining(remainingMs);

    timerElements.forEach((element) => {
      const valueNode = element.querySelector('[data-cart-timer-value]');
      if (valueNode) valueNode.textContent = formatted;
      element.hidden = false;
    });
  };

  const start = () => {
    render();
    window.setInterval(render, TICK_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
